import { HistoryItemType } from '../types';
import { ShipmentHistorySecondDto } from '../types/service.dto';

export function filterShipmentHistoryFromResponse(
  response: ShipmentHistorySecondDto,
): HistoryItemType {
  const data: HistoryItemType = {
    carrierCode: response.carrierCode,
    serviceLevel: response.serviceLevel,
    selectedService: response.selectedService,
    serviceName: response.serviceLevel || '',
    packageType: response.packageType || 'MyPackage',
    shipDateTime: response.shipDate,
    trackingNumber: response.trackingNumber,
    carrierTrackingUrl: response.carrierTrackingUrl,
    myAccount: response.myAccount,
    myAccountNumber: response.myAccountNumber,
    hasComments: response.hasComments,
    username: response.username,
    createdBy: response.createdBy,
    fromAddress: response.fromAddress,
    toAddress: response.toAddress,
    packages: response.packages.map((packageItem) => ({
      packageType: packageItem.packageType,
      weight: packageItem.weight,
      length: packageItem.length,
      width: packageItem.width,
      height: packageItem.height,
      dimUnits: packageItem.dimUnits,
      weightUnits: packageItem.weightUnits,
      insurance: packageItem.insurance,
      isAdditionalHandling: packageItem.isAdditionalHandling,
      description: packageItem.description,
      signatureOptions: packageItem.signatureOptions,
      shipStatus: packageItem.shipStatus,
      lastScan: packageItem.lastScan || '',
      carrierTrackingNumber: packageItem.carrierTrackingNumber,
      userDefinedPackageType: packageItem.userDefinedPackageType,
    })),
    deliveryEmail: response.deliveryEmail,
    billing: {
      account: response.billing.account || '',
      billingType: response.billing.billingType,
    },
    quotedPrice: response.quotedPrice,
    deleted: response.deleted,
    signatureOption: response.signatureOption,
    onTime: response.onTime || '',
    cutoffTime: response.cutoffTime,
    reference: response.reference,
    comment: response.comment,
    isDocumentsOnly: response.documentsOnly,
    actualPrice: response.actualPrice,
    invoiceNumber: response.invoiceNumber,
    isReturnShipment: response.isReturnShipment,
    isLabelFree: response.isLabelFree,
    isBoxFree: response.isBoxFree,
    qrCode: response.qrCode,
    qrCodeExpiryDate: response.qrCodeExpiryDate,
  };

  const { commercialInvoice } = response;
  if (commercialInvoice) {
    data.commercialInvoice = {
      broker: {
        name: commercialInvoice.broker.name || '',
      },
      customsParts: commercialInvoice.customsParts.map((item) => ({
        quantity: item.quantity,
        detailedDescription: item.detailedDescription || '',
        countryOfOrigin: item.countryOfOrigin,
        hsCode: item.hsCode || '',
        unitValue: item.unitValue,
        quantityUnits: item.quantityUnits || '',
        nickname: item.nickname,
        merchantProductId: item.merchantProductId || '',
        manufacturerProductId: item.manufacturerProductId || '',
        standardProductId: item.standardProductId || '',
      })),
      declarationStatement: commercialInvoice.declarationStatement || '',
      currencyCode: commercialInvoice.currencyCode || '',
      reasonForExport: `${commercialInvoice.reasonForExport}`,
      remarks: commercialInvoice.remarks || '',
      generalDescriptionOfGoods: commercialInvoice.generalDescriptionOfGoods || '',
      taxId: commercialInvoice.taxId,
    };
  }

  if (response.uploadDocuments && response.uploadDocuments.length) {
    data.uploadDocuments = response.uploadDocuments;
  }

  const { ecommerce } = response;
  if (ecommerce) {
    data.ecommerce = {
      id: 0,
      platformType: ecommerce.platformType,
      shopDetails: {
        name: ecommerce.shopDetails.name || '',
        url: ecommerce.shopDetails.url || '',
      },
      uniqueOrderId: ecommerce.uniqueOrderId || '',
      orderId: ecommerce.orderId || '',
      fulfillOrder: ecommerce.fulfillOrder,
      storeNotification: ecommerce.storeNotification,
      connectionId: ecommerce.connectionId,
    };
  }

  return data;
}
